import type { RouteInputKey } from "./types";

// Trays are left out on purpose: a tray edit is re-routed plan-wide by Recalculate, not circuit by circuit.

const at = ({ x, y }: { x: number; y: number }): string => `${x.toFixed(1)},${y.toFixed(1)}`;

export const routeInputKey: RouteInputKey = ({
  circuitId,
  source,
  destinations,
  noTraySurchargePct,
}) => {
  const devices = destinations
    .map(
      (destination) =>
        `${destination.elementId}${destination.role ? `:${destination.role}` : ""}@${at(destination.position)}`,
    )
    .sort()
    .join(";");
  return `${circuitId}|${at(source)}|${devices}|${noTraySurchargePct}`;
};
